<template>
  <div id="app" :class="pageName">
    <Nav/>
    <router-view/>
    <Footer v-if="showFooter"/>
    <a href="https://www.wjx.cn/vm/t9gPiBR.aspx#" class="customerService" target="_blank"></a>
  </div>
</template>

<script>
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'
import '@/assets/normalize.css'
import '@/assets/common.less'
import 'element-ui/lib/theme-chalk/index.css'
export default {
  name: 'App',
  components: {
    Nav,
    Footer
  },
  computed: {
    pageName() {
      return this.$route.name
    },
    showFooter() {
      const page = this.$route.name
      if (page === 'Busi' || page === 'Home' || page === 'News' || page === 'NewsCata') {
        return false
      }
      return true
    }
  },
  mounted() {

  }
}
</script>
